import { OnInit, ChangeDetectorRef } from '@angular/core';
import { UsersService } from '../../../services/users.service';
import { NotificationsService } from '../../../services/notification.service';
import { LocalisationService } from '../../../services/localisation.service';
import { forkJoin } from 'rxjs';
import { ProductsService } from '../../../services/products.service';
var BodySectionComponent = /** @class */ (function () {
    function BodySectionComponent(usersService, notificationService, localisationService, changeDetectorRef, productsService) {
        this.usersService = usersService;
        this.notificationService = notificationService;
        this.localisationService = localisationService;
        this.changeDetectorRef = changeDetectorRef;
        this.productsService = productsService;
        this.editable = true;
        this.notifications = true;
        this.loading = true;
        this.enabledByAllergy = {};
        // Protocol-related properties (protocol is read-only, set by admin)
        this.currentProtocol = null;
        this.isProtocolEnabled = false;
        this.isDuplicateDaysEnabled = false;
        this.isDinnerSameForLunchEnabled = false;
        this.maxProductPerRecipe = 5;
        this.useSimilarProductsBetweenRecipes = true;
    }
    BodySectionComponent.prototype.ngOnInit = function () {
        var _this = this;
        forkJoin(this.usersService.getUserDailyMeals(), this.usersService.getUserDiets(), this.productsService.getAllergies(), this.usersService.getUserTrainingTargets()).subscribe(function (_a) {
            var dailyMeals = _a[0], diets = _a[1], allergies = _a[2], trainingTargets = _a[3];
            _this.dailyMeals = dailyMeals;
            _this.diets = diets;
            _this.allergies = allergies;
            _this.trainingTargets = trainingTargets;
            _this.loading = false;
            _this.changeDetectorRef.detectChanges();
            if (_this.usersService.userProfile) {
                _this.initCurrentUserProfile(_this.usersService.userProfile);
            }
        });
    };
    BodySectionComponent.prototype.updateProfile = function () {
        var _this = this;
        this.loading = true;
        var trainingTarget = null;
        if (this.currentlySelectedTrainingTarget) {
            trainingTarget = { id: this.currentlySelectedTrainingTarget.id };
        }
        // Base profile data
        var profileData = {
            daily_meals: {
                id: this.currentlySelectedDailyMeal.id
            },
            diet: this.currentlySelectedDiet ? { id: this.currentlySelectedDiet.id } : null,
            allergies: Object.keys(this.enabledByAllergy).filter(function (k) { return _this.enabledByAllergy[k]; }).map(function (k) { return +k; }).map(function (id) {
                return { id: id };
            }),
        };
        // Only add protocol-related settings if protocol is enabled by admin
        if (this.isProtocolEnabled) {
            // Don't send protocol object - it's managed by admin, only send user settings
            profileData.is_duplicate_days_enabled = this.isDuplicateDaysEnabled;
            profileData.is_dinner_same_for_lunch_enabled = this.isDinnerSameForLunchEnabled;
            profileData.max_product_per_recipe = this.maxProductPerRecipe;
            profileData.use_similar_products_between_recipes = this.useSimilarProductsBetweenRecipes;
        }
        this.usersService
            .updateUserProfile(profileData)
            .subscribe(function () {
            _this.loading = false;
            _this.changeDetectorRef.detectChanges();
            if (_this.notifications) {
                _this.notificationService.success(_this.localisationService.localise('settings_profile_updated_successfully'));
            }
        });
    };
    Object.defineProperty(BodySectionComponent.prototype, "saveButtonIsDisabled", {
        get: function () {
            return !this.currentlySelectedDailyMeal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BodySectionComponent.prototype, "showProtocolSection", {
        // Getter to check if protocol section should be visible (only if protocol is enabled by admin)
        get: function () {
            return this.isProtocolEnabled;
        },
        enumerable: true,
        configurable: true
    });
    BodySectionComponent.prototype.initCurrentUserProfile = function (userProfile) {
        this.currentlySelectedDailyMeal = userProfile.daily_meals ? this.dailyMeals.find(function (dm) { return dm.id === userProfile.daily_meals.id; }) : undefined;
        this.currentlySelectedDiet = userProfile.diet ? this.diets.find(function (d) { return d.id === userProfile.diet.id; }) : undefined;
        this.currentlySelectedTrainingTarget = userProfile.training_target ? this.trainingTargets.find(function (tt) { return tt.id === userProfile.training_target.id; }) : undefined;
        // Initialize protocol-related fields (protocol is read-only, assigned by admin)
        this.isProtocolEnabled = userProfile.is_protocol_enabled || false;
        if (this.isProtocolEnabled && userProfile.protocol) {
            this.currentProtocol = userProfile.protocol;
            this.isDuplicateDaysEnabled = userProfile.is_duplicate_days_enabled || false;
            this.isDinnerSameForLunchEnabled = userProfile.is_dinner_same_for_lunch_enabled || false;
            this.maxProductPerRecipe = userProfile.max_product_per_recipe || 5;
            this.useSimilarProductsBetweenRecipes = userProfile.use_similar_products_between_recipes !== undefined ? userProfile.use_similar_products_between_recipes : true;
        }
        else {
            // Reset protocol settings if protocol is not enabled
            this.currentProtocol = null;
            this.isDuplicateDaysEnabled = false;
            this.isDinnerSameForLunchEnabled = false;
            this.maxProductPerRecipe = 5;
            this.useSimilarProductsBetweenRecipes = true;
        }
        this.initEnabledByAllergy(userProfile);
        this.changeDetectorRef.markForCheck();
    };
    BodySectionComponent.prototype.initEnabledByAllergy = function (userProfile) {
        var _this = this;
        this.allergies.forEach(function (a) { return _this.enabledByAllergy[a.id] = false; });
        if (userProfile.allergies) {
            userProfile.allergies.forEach(function (a) {
                _this.enabledByAllergy[a.id] = true;
            });
        }
    };
    return BodySectionComponent;
}());
export { BodySectionComponent };
